import { PERFORMANCE_TYPE_KEYS } from 'src/app/product-capture/model/consts/performance-type.const';
import { BaseTypeEnum } from '../../../product-capture/model/consts/participation-base-type.const';
import { ProductTypeEnum } from '../../../product-capture/model/enums/product-capture.enums';
import {
  PAYOFF_CALLABILITY_CALLABILITY,
  PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
  PAYOFF_COUPON,
  PAYOFF_COUPON_TYPE,
  PAYOFF_PARTICIPATION,
  PAYOFF_PARTICIPATION_BASE_CAPPED,
  PAYOFF_PARTICIPATION_BASE_GLOBAL_CAP,
  PAYOFF_PARTICIPATION_BASE_INITIAL_LEVEL_AS_DENOMINATION,
  PAYOFF_PARTICIPATION_BASE_ISSUE_AT_DISCOUNT,
  PAYOFF_PARTICIPATION_BASE_STRIKE,
  PAYOFF_PARTICIPATION_BASE_TYPE,
  PAYOFF_PARTICIPATION_BASE_UPPER_PARTICIPATION,
  PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE,
  PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
  PAYOFF_PARTICIPATION_UPSIDE_TYPE,
  SUMMARY_FREQUENCY,
  SUMMARY_PERFORMANCE_TYPE,
  SUMMARY_REFERENCE_ENTITIES,
  SUMMARY_SETTLEMENT_TYPE,
  SUMMARY_UNDERLYING_ASSETS_GROUP,
} from '../../mockups/consts/product-capture-field-selectors.consts';
import { FCFieldEffect } from '../form-config.interface';

export const DISCOUNT_CERTIFICATE_SETTINGS: {
  id: ProductTypeEnum;
  label: string;
  effects: FCFieldEffect[];
} = {
  id: ProductTypeEnum.DISCOUNT_CERTIFICATE,
  label: 'Discount Certificate',
  effects: [
    {
      formControlNames: [
        PAYOFF_COUPON_TYPE,
        PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
        PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
        PAYOFF_PARTICIPATION_UPSIDE_TYPE,
        PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE,
      ],
      selectValues: ['NONE'],
      hidden: true,
    },
    {
      formControlNames: [
        SUMMARY_REFERENCE_ENTITIES,
        PAYOFF_COUPON,
        PAYOFF_PARTICIPATION,
        PAYOFF_CALLABILITY_CALLABILITY,
      ],
      hidden: true,
    },
    {
      formControlNames: [
        SUMMARY_UNDERLYING_ASSETS_GROUP,
        PAYOFF_PARTICIPATION_BASE_TYPE,
      ],
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_BASE_TYPE],
      selectValues: [''],
    },
    {
      formControlNames: [SUMMARY_SETTLEMENT_TYPE],
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_BASE_STRIKE],
      readOnly: false,
      hidden: false,
      defaultUnit: 'abs',
      label: 'Discount Price',
      selectValues: [null],
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_BASE_TYPE],
      selectValues: [BaseTypeEnum.DISCOUNT_CERTIFICATE],
      hidden: false,
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_BASE_UPPER_PARTICIPATION],
      defaultUnit: 'abs',
      selectValues: [
        {
          value: '1',
          minValue: null,
          indicativeValue: null,
          maxValue: null,
        },
      ],
    },
    {
      formControlNames: [
        PAYOFF_PARTICIPATION_BASE_INITIAL_LEVEL_AS_DENOMINATION,
        PAYOFF_PARTICIPATION_BASE_ISSUE_AT_DISCOUNT,
      ],
      hidden: false,
      readOnly: false,
      selectValues: [true],
    },
    {
      formControlNames: [SUMMARY_PERFORMANCE_TYPE],
      selectValues: [PERFORMANCE_TYPE_KEYS.SINGLE],
    },
    {
      formControlNames: [SUMMARY_SETTLEMENT_TYPE],
      selectValues: ['CASH_OR_PHYSICAL'],
    },
    {
      formControlNames: [SUMMARY_FREQUENCY],
      selectValues: ['AT_MATURITY'],
    },
    {
      formControlNames: [SUMMARY_FREQUENCY, SUMMARY_PERFORMANCE_TYPE],
      readOnly: true,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_BASE_CAPPED],
      selectValues: [false],
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_BASE_GLOBAL_CAP],
      defaultUnit: 'abs',
    },
  ],
};
